import { useCallback, useState } from "react";

export const useHandleRecenter = () => {
  const [recenterRequestFlag, setRecenterRequestFlag] = useState<number>(0);
  const callForRecenter = useCallback(() => {
    setRecenterRequestFlag((prev) => prev + 1);
  }, [setRecenterRequestFlag]);

  return {
    callForRecenter,
    recenterRequestFlag,
  };
};
